import { useTranslation } from 'react-i18next';

import VectorImage from '~components/media/vectorImage';

import getInteractiveBatteryIconData from './interactiveBatteryData';

interface BatteryProps {
	value: number;
}

const InteractiveBatteryIcon = (props: BatteryProps) => {
	const { t } = useTranslation();
	const data = getInteractiveBatteryIconData(props.value, t);
	return <VectorImage name={data.icon} />;
};

export default InteractiveBatteryIcon;
